import imageOne from '@/assets/images/cities/barrie1.jpg'
import imageTwo from '@/assets/images/cities/barrie2.jpg'
import imageThree from '@/assets/images/cities/barrie3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Barrie Area',
  writeup: '',
  website: 'BarrieNotaryPublic.com',
  url: 'https://www.barrienotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '',
      hours: {
        monday: '9:00AM to 4:30PM',
        tuesday: '9:00AM to 4:30PM',
        wednesday: '9:00AM to 4:30PM',
        thursday: '9:00AM to 4:30PM',
        friday: '',
        saturday: '',
        sunday: ''
      },
      address: 'Mill Street, Angus ON Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/barrie.js